import React, { useEffect, useRef, useState } from "react";
import { Stack, Button, Typography, IconButton, Box, styled } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { MessageChatText } from "components/typography/text";
import moment from 'moment-jalaali';

const ChatCardContainer = styled(Stack)(
    ({ theme }) => `
        border-radius: 12px;
        min-width: 10%;
        max-width: 300px;
        border: 1px solid rgba(238, 238, 238, 0.93);
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.10);
        padding: ${theme.spacing(1)} ${theme.spacing(1.5)};
    `
)


export default function MessageChatCard({ audio, isMine, seen, data, trigerToBottom }) {

    const { Text, CreatedDate } = data

    const mainBackColor = isMine ? "#F9F9F9" : "#FFFFFF"

    //always scrolling bottom of chat on loading chat when in chat
    useEffect(() => {
        if(trigerToBottom) {
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        }
    }, [])

    return(
        <Stack alignItems={isMine ? "flex-start" : "flex-end"}>
            <ChatCardContainer sx={{background: mainBackColor}} spacing={1}>
                <Stack direction="row" alignItems="center">
                    <MessageChatText>{Text}</MessageChatText>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    {
                        isMine &&
                        (
                            seen ?
                            <DoneAllIcon fontSize="14px" color="success" />
                            :
                            <CheckIcon fontSize="14px" color="success" />
                        )
                    }
                    <Typography variant="caption" color="text.secondary">{moment(CreatedDate).format("HH:mm")}</Typography>
                </Stack>
            </ChatCardContainer>
        </Stack>
    )
}